var DialogSize;
(function (DialogSize) {
  DialogSize["sm"] = "sm";
  DialogSize["md"] = "md";
  DialogSize["lg"] = "lg";
})(DialogSize || (DialogSize = {}));

export { DialogSize };
